import createContext from './utils/createContext';
import translateDOMPositionXY from './utils/translateDOMPositionXY';
import isRTL from './utils/isRTL';
const TableContext = createContext({
    rlt: isRTL(),
    hasCustomTreeCol: false,
    isTree: false,
    translateDOMPositionXY,
});
export default TableContext;
